/* Produktseite: Lagerbestand als Anzeige, Vorteile als Chips, Lieferschaetzung. Laeuft nach jedem Neuladen der Produktinfos (Variantenwechsel) erneut. */
(function(){
var S='fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"';
var I={
shield:'<svg viewBox="0 0 24 24" '+S+'><path d="M12 3l8 3v6c0 4.5-3.2 8-8 9-4.8-1-8-4.5-8-9V6z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg>',
truck:'<svg viewBox="0 0 24 24" '+S+'><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7zM7 19a1.8 1.8 0 100-3.6A1.8 1.8 0 007 19zM17 19a1.8 1.8 0 100-3.6 1.8 1.8 0 000 3.6z"/></svg>',
package:'<svg viewBox="0 0 24 24" '+S+'><path d="M21 8l-9-5-9 5v8l9 5 9-5zM3 8l9 5 9-5M12 13v8"/></svg>',
lock:'<svg viewBox="0 0 24 24" '+S+'><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 018 0v3"/></svg>',
clock:'<svg viewBox="0 0 24 24" '+S+'><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>'};
function stock(){
 var p=document.querySelector('.product__info-container .product__inventory');
 if(!p||p.querySelector('.eg-stock__txt'))return;
 var t=p.textContent.trim().replace(/\s+/g,' ');
 if(!t)return;
 var m=t.match(/(\d+)/);var n=m?parseInt(m[1],10):null;
 var lvl='ok',h,s;
 if(/nicht auf lager|ausverkauft|nicht vorr/i.test(t)){lvl='out';h='Aktuell ausverkauft';s='Schau bald wieder vorbei'}
 else if(/niedrig/i.test(t)){lvl='low';h='Nur noch '+n+' verfügbar';s='Fast weg – wer zuerst kommt, sammelt zuerst'}
 else{h='Auf Lager';s=(n?n+' Stück':'Sofort')+' bereit zum Versand'}
 var w=lvl==='out'?0:(n==null?100:Math.max(8,Math.min(100,Math.round(n/20*100))));
 p.classList.remove('eg-stock--ok','eg-stock--low','eg-stock--out');
 p.classList.add('eg-stock','eg-stock--'+lvl);
 p.innerHTML='<span class="eg-stock__dot"></span><span class="eg-stock__txt"><strong>'+h+'</strong><small>'+s+'</small></span><span class="eg-stock__bar"><i style="--w:'+w+'%"></i></span>';
}
function chips(){
 var ic=document.querySelector('.product__info-container');
 if(!ic||ic.querySelector('.eg-chips'))return;
 var ps=Array.prototype.filter.call(ic.querySelectorAll(':scope > p.product__text'),function(e){return /^\s*-\s/.test(e.textContent)});
 if(!ps.length)return;
 var box=document.createElement('div');box.className='eg-chips';ps[0].before(box);
 ps.forEach(function(e){
  var tx=e.textContent.replace(/^\s*-\s*/,'').replace(/^[^\p{L}\p{N}]+/u,'').trim();
  var k=/versand/i.test(tx)?'truck':/verpackt/i.test(tx)?'package':'shield';
  var c=document.createElement('div');c.className='eg-chip';c.innerHTML=I[k]+'<span>'+tx+'</span>';box.appendChild(c);e.remove();
 });
}
function wd(d,n){var x=new Date(d);while(n>0){x.setDate(x.getDate()+1);var g=x.getDay();if(g!==0&&g!==6)n--}return x}
function assure(){
 var ic=document.querySelector('.product__info-container');
 if(!ic)return;
 var out=!!ic.querySelector('.eg-stock--out');
 var old=ic.querySelector('.eg-assure');
 if(old&&(!!old.querySelector('.eg-eta')===!out))return;
 if(old)old.remove();
 var anchor=ic.querySelector('.product-popup-modal__opener')||ic.querySelector('.eg-chips');
 if(!anchor)return;
 var f=function(d){return d.toLocaleDateString('de-DE',{weekday:'short',day:'2-digit',month:'short'})};
 var now=new Date();var a=wd(now,2),b=wd(now,4);
 var box=document.createElement('div');box.className='eg-assure';
 box.innerHTML=(out?'':'<div class="eg-eta">'+I.clock+'<span>Bestellst du jetzt, kommt es voraussichtlich zwischen <b>'+f(a)+'</b> und <b>'+f(b)+'</b> bei dir an.</span></div>')+'<div>'+I.lock+'<span>Sichere Bezahlung, deine Daten sind verschlüsselt.</span></div>';
 anchor.before(box);
}
function run(){stock();chips();assure()}
function init(){
 run();
 var ic=document.querySelector('.product__info-container');
 if(ic&&'MutationObserver' in window){var t;new MutationObserver(function(){clearTimeout(t);t=setTimeout(run,30)}).observe(ic,{childList:true,subtree:true})}
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
